import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import { challengeContextAction, presignedAction } from "../../../actions";
import { RootState } from "../../../reducers";
import EditorReadme from "./EditorReadme";

interface OwnProps {
  challengeId: number;
}

const mapStateToProps = (state: RootState, props: OwnProps) => ({
  ...props,
  exam: state.applicant.exam,
  challengeContext: state.applicant.challengeContext,
  readme: state.applicant.challengeSourceFiles.find(
    (file) => file.name === "README.md",
  ),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  getPresigned: (payload: {}, params: {}) => {
    dispatch(presignedAction.request(payload, params));
  },
  getChallengeContext: (params: {}) => {
    dispatch(challengeContextAction.request({}, params));
  },
});

const wrappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditorReadme);

export default wrappedComponent;
